// home namespace — HomePage.vue, HeroCarousel.vue
export default {
  en: {
    trust: {
      delivery: 'Instant delivery',
      seller: 'EU seller · VAT invoice',
      stock: '{count} keys in stock',
      payments: 'Stripe & PayPal · card data never touches our servers',
    },
    price: {
      heading: 'Shop by price',
      under5: 'Under 5 €',
      from5to10: '5 – 10 €',
      from10to20: '10 – 20 €',
      over20: '20 € and up',
      count: '{count} game | {count} games',
    },
    giftCards: {
      heading: 'Gift cards & top-ups',
    },
    howItWorks: {
      heading: 'How GAMZOR works',
      step1: { title: 'Pick a game', body: 'Every card shows platform, price and offers up front.' },
      step2: { title: 'Pay your way', body: 'Card, PayPal or your GAMZOR wallet, with a VAT invoice.' },
      step3: { title: 'Get the key instantly', body: 'It lands the moment your payment clears.' },
      payWith: 'Pay with',
      wallet: 'GAMZOR wallet',
      invoice: 'VAT invoice for every payment',
      keyLabel: 'Your key',
      delivered: 'Appears in your orders and inbox',
    },
    genres: {
      heading: 'Browse by genre',
    },
    rows: {
      recent: 'Recently viewed',
      bestsellers: 'Bestsellers',
      deals: 'Deals',
      newest: 'New releases',
      under5: 'Under 5 €',
      seeAll: 'See all',
      scrollBack: 'Scroll back',
      scrollForward: 'Scroll forward',
    },
    platforms: {
      heading: 'Choose your platform',
      browse: 'Browse',
      comingSoon: 'Coming soon',
    },
    marketplace: {
      empty: 'Nothing in stock right now — check back soon.',
      error: 'We couldn’t load the catalog.',
    },
    promo: {
      under5: { title: '{count} game under 5 € | {count} games under 5 €', sub: 'Same instant key, smaller price. Every platform.', cta: 'Shop under 5 €' },
      wallet: { title: 'Pay from your wallet', sub: 'Top up once, buy in one tap. VAT invoices for every top-up.', cta: 'Open wallet' },
    },
    journal: {
      heading: 'From our journal',
      allArticles: 'All articles',
      articleLabel: 'Article',
    },
    hero: {
      featured: 'Featured',
      rotatesIn: 'New picks in',
      buyNow: 'Buy now',
      fallback: {
        badge: 'Verified marketplace',
        deliveryLabel: 'Instant delivery',
        title: 'Instant game keys',
        titleAccent: 'verified & secure',
        body: 'Thousands of titles across every major platform, sourced from authorized distributors and delivered the moment your payment clears.',
        browseCatalog: 'Browse catalog',
        howItWorks: 'How it works',
      },
      slide: 'Slide {index} of {total}: {name}',
      prevSlide: 'Previous slide',
      nextSlide: 'Next slide',
      goToSlide: 'Go to slide {index}',
    },
  },
  cs: {
    trust: {
      delivery: 'Okamžité doručení',
      seller: 'Prodejce z EU · faktura s DPH',
      stock: '{count} klíčů skladem',
      payments: 'Stripe a PayPal · údaje karty k nám nikdy nedorazí',
    },
    price: {
      heading: 'Podle ceny',
      under5: 'Do 5 €',
      from5to10: '5 – 10 €',
      from10to20: '10 – 20 €',
      over20: '20 € a více',
      count: '{count} hra | {count} hry | {count} her',
    },
    giftCards: {
      heading: 'Dárkové karty a dobití',
    },
    howItWorks: {
      heading: 'Jak GAMZOR funguje',
      step1: { title: 'Vyberte hru', body: 'Každá karta ukazuje platformu, cenu a nabídky hned na první pohled.' },
      step2: { title: 'Zaplaťte po svém', body: 'Kartou, přes PayPal nebo z peněženky GAMZOR, s fakturou s DPH.' },
      step3: { title: 'Klíč ihned', body: 'Dorazí ve chvíli, kdy platba projde.' },
      payWith: 'Zaplatit přes',
      wallet: 'Peněženka GAMZOR',
      invoice: 'Faktura s DPH ke každé platbě',
      keyLabel: 'Váš klíč',
      delivered: 'Objeví se v objednávkách a v e-mailu',
    },
    genres: {
      heading: 'Podle žánru',
    },
    rows: {
      recent: 'Naposledy zobrazené',
      bestsellers: 'Nejprodávanější',
      deals: 'Slevy',
      newest: 'Novinky',
      under5: 'Do 5 €',
      seeAll: 'Zobrazit vše',
      scrollBack: 'Posunout zpět',
      scrollForward: 'Posunout vpřed',
    },
    platforms: {
      heading: 'Vyberte platformu',
      browse: 'Procházet',
      comingSoon: 'Již brzy',
    },
    marketplace: {
      empty: 'Momentálně nic skladem — zkuste to brzy znovu.',
      error: 'Katalog se nepodařilo načíst.',
    },
    promo: {
      under5: { title: '{count} hra do 5 € | {count} hry do 5 € | {count} her do 5 €', sub: 'Stejně rychlý klíč, menší cena. Pro každou platformu.', cta: 'Nakoupit do 5 €' },
      wallet: { title: 'Plaťte z peněženky', sub: 'Dobijte jednou, nakupujte na jedno klepnutí. Faktura s DPH ke každému dobití.', cta: 'Otevřít peněženku' },
    },
    journal: {
      heading: 'Z našeho žurnálu',
      allArticles: 'Všechny články',
      articleLabel: 'Článek',
    },
    hero: {
      featured: 'Doporučeno',
      rotatesIn: 'Nový výběr za',
      buyNow: 'Koupit nyní',
      fallback: {
        badge: 'Ověřené tržiště',
        deliveryLabel: 'Okamžité doručení',
        title: 'Okamžité herní klíče',
        titleAccent: 'ověřené a bezpečné',
        body: 'Tisíce titulů na všech hlavních platformách, od ověřených distributorů – doručeny ihned po potvrzení platby.',
        browseCatalog: 'Procházet katalog',
        howItWorks: 'Jak to funguje',
      },
      slide: 'Snímek {index} z {total}: {name}',
      prevSlide: 'Předchozí snímek',
      nextSlide: 'Další snímek',
      goToSlide: 'Přejít na snímek {index}',
    },
  },
};
